import * as Types from './types';
import { actionTypes } from './constants';
import { TGamesFeedParsed, TFilterSortBy } from '../types';

export const toggleIsLoading = (isLoading: boolean): Types.IToggleIsLoadingAction => ({
    type: actionTypes.GAMES_GRID_IS_LOADING_TOGGLE,
    payload: isLoading
});

export const toggleFilterPopup = (isOpened: boolean): Types.IToggleFilterPopupAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_FILTER_POPUP_TOGGLE,
    payload: isOpened
});

export const updateGamesFeedName = (feedName: string): Types.IGamesFeedNameUpdateAction => ({
    type: actionTypes.GAMES_GRID_FEED_NAME_UPDATE,
    payload: feedName
});

export const updateFilterCategory = (categoryName: string): Types.IFilterCategoryUpdateAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_CATEGORY_UPDATE,
    payload: categoryName
});

export const updateFilterSortBy = (filterValue: TFilterSortBy): Types.IFilterSortByUpdateAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_SORT_BY_UPDATE,
    payload: filterValue
});

export const updateFilterProviders = (provider: string): Types.IFilterProvidersUpdateAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_PROVIDERS_UPDATE,
    payload: provider
});

export const updateFilterLabels = (label: string): Types.IFilterLabelsUpdateAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_LABELS_UPDATE,
    payload: label
});

export const updateAllFilters = (filters: {
    filterCategory: string;
    filterLabels: string;
    filterProviders: string;
    filterSortBy: TFilterSortBy;
    filterCustomFields: {[key: string]: string};
}): Types.IFilterAllUpdateAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_ALL_UPDATE,
    payload: filters
});

export const resetFilters = (): Types.IFilterResetAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_RESET
});

export const updateFilterCustomField = ({ fieldName, value }: {
    fieldName: string; value: string;
}): Types.IFilterCustomFieldUpdateAction => ({
    type: actionTypes.GAMES_GRID_FILTERS_CUSTOM_FIELD_UPDATE,
    payload: { fieldName, value }
});

export const updateGamesFeed = (gamesFeed: TGamesFeedParsed): Types.IGamesFeedUpdateAction => ({
    type: actionTypes.GAMES_GRID_FEED_UPDATE,
    payload: gamesFeed
});

export const setActiveTab = (tabName: string): Types.IActiveTabUpdateAction => ({
    type: actionTypes.GAMES_GRID_ACTIVE_TAB_UPDATE,
    payload: tabName
});

export const updateRecentlyPlayedCategory = (gameCodes: string[]): Types.IRecentlyPlayedCategoryUpdateAction => ({
    type: actionTypes.GAMES_GRID_RECENTLY_PLAYED_CATEGORY_UPDATE,
    payload: gameCodes
});

export const updateFavoriteGames = (gameCodes: string[]): Types.IFavoritesUpdateAction => ({
    type: actionTypes.GAMES_GRID_FAVORITES_UPDATE,
    payload: gameCodes
});
